import { render, staticRenderFns } from "./tagsList.vue?vue&type=template&id=43274a6e&scoped=true"
import script from "./tagsList.vue?vue&type=script&lang=js"
export * from "./tagsList.vue?vue&type=script&lang=js"
import style0 from "./tagsList.vue?vue&type=style&index=0&id=43274a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43274a6e",
  null
  
)

export default component.exports